module.exports = __webpack_public_path__ + "img/row-left.1f6e4eb1.svg";